import { clearPendingOrder, readStoredJSON } from '../utils/pendingOrder';
import { actionTextColor } from "../utils/themeContrast";
import React, { useEffect, useState } from "react";
import { ThemeContext, ActionContext, UserContext, LanguageContext } from "../contexts/Context";
import styled from "@emotion/styled";
import { Link } from "@reach/router";

import ReviewOrderModal from "../newcomponents/ReviewOrderModal";
import useWindowDimensions from "../hooks/useWindowDimensions";
import axios from "axios";
import OrderReceipt, { OrderIdentity } from "../newcomponents/OrderReceipt";
import { readableText, lightTint } from "../utils/themeContrast";
import promo from '../newcomponents/customerComponents/Promotion';
const Success = () => {

  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const { addTakeAwayId, clearCart, setFinalOrder, setRedeem, setDiscount: resetDiscount, addVoucher, addPromotion } = React.useContext(ActionContext);
  const { pm } = React.useContext(UserContext);
  const { isTakeAway, tkSuccessMessage, lanIndex, successMessage, payAtCounter, company, isInRoom, tkType } = React.useContext(UserContext);
  const { currencySymbol, paymentData, tax, userId, orderTime } = React.useContext(UserContext);

  const [totalAmount, setTotalAmount] = useState(0);
  const [pickUpTime, setPickUpTime] = useState("");
  const [showOrder, setShowOrder] = useState(false);
  const [cartHistory, setCartHistory] = useState([]);
  const [subtotalHistory, setSubtotalHistory] = useState(0);
  const [subtotalDefaultHistory, setSubtotalDefaultHistory] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [takeAwayId, setTakeAwayId] = useState("");
  const { height, width } = useWindowDimensions();
  const [discount, setDiscount] = useState(null);
  const [bcrsNo, setBCRSNo] = useState(0);
  const [tableLabel, setTableLabel] = useState("");
  const [deliveryType, setDeliveryType] = useState(-1);
  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [scheduleTime, setScheduleTime] = useState(0);
  const [serviceAmt, setServiceAmt] = useState(0);
  const [hasPaid, setHasPaid] = useState(false);

  useEffect(() => {
    if (!readStoredJSON("finalOrder")) localStorage.removeItem("order");
  }, []);

  useEffect(() => {
    let serviceAmt = ((!isTakeAway && !paymentData.shouldExcludeDI) ? paymentData.serviceCharge : ((isTakeAway && !paymentData.shouldExclude) ? paymentData.serviceCharge : 0));
    setServiceAmt(serviceAmt);
  }, [paymentData]);

  useEffect(() => {
    let orderId = getCookie("orderId");
    let token = getCookie("token");

    if (!token) return;
    axios.get(
      `/v2/api/selfOrder/takeAwayId?orderId=${orderId}`,
      { headers: { Authorization: "Bearer " + token } }
    )
      .then(function (response) {
        // handle success
        addTakeAwayId(response.data.takeAwayId);
        setTakeAwayId(response.data.takeAwayId);
        setTotalAmount(response.data.totalAmount);
        setPickUpTime(response.data.scheduleTime);
        setHasPaid(response.data.hasPaid);
        if (response.data.hasPaid === true || response.data.hasPaid === 1 ||
            response.data.hasPaid === "true" || response.data.hasPaid === "1" ||
            (response.data.totalAmount !== '' && response.data.totalAmount != null &&
              Number(response.data.totalAmount) === 0)) {
          if (clearPendingOrder(orderId)) {
            clearCart();
            setFinalOrder(null);
            setRedeem([]);
            resetDiscount(null);
            addVoucher([]);
            addPromotion((pm || []).filter(p => !p.isVoucher && !p.customerRewardId));
          }
        }
        setTableLabel(response.data.tableLabel);
      })
      .catch(function (response) {
        // handle error
      
      });
    // Pending checkout is cleared only after confirmed success above.
    //get order data also
    axios.get(`/v2/api/selfOrder/order?userId=${userId}&orderTime=${orderTime}&orderId=${orderId}`, {
      headers: { Authorization: "Bearer " + token },
    })
      .then(function (response) {
        // handle success
        setDiscount(response.data.discount);
        setCartHistory(response.data.orderData);
        setSubtotalDefaultHistory(promo.subTotalDefaultAmount(response.data.orderData));
        setSubtotalHistory(promo.subTotalAmount(response.data.orderData));
        setBCRSNo(promo.getBCRSNo(response.data.orderData, isTakeAway, response.data.deliveryType));
        setDeliveryType(response.data.deliveryType);
        setPhone(response.data.phone);
        setCustomerName(response.data.customerName);
        setScheduleTime(response.data.scheduleTime);
        setAddress(response.data.address);
        setDeliveryFee(response.data.deliveryFee);

      })
      .catch(function (response) {
      
      })

  }, [addTakeAwayId]);

  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );

    return match ? decodeURIComponent(match[2]) : null;
  }

  const handlingView = () => {
    setShowOrder(true);
  }

  if (typeof lanIndex === 'undefined') {
    return <></>
  }
  return (
    <BackgroundColor themeContext={themeContext}>
      <Circle className="circle">
        <CheckIcon className="checkmark">&#10003;</CheckIcon>
      </Circle>

      <Header className="header" payAtCounter={payAtCounter}>{hasPaid ? languageContext[lanIndex].success : (payAtCounter ? languageContext[lanIndex].pendingOrder : languageContext[lanIndex].orderSubmit)}</Header>
      <div style={{ padding: "0 16px" }}><OrderIdentity takeAwayId={takeAwayId} tableLabel={tableLabel}/></div>
      {isTakeAway && pickUpTime &&
        <Paragraph3 className="paragraph">
          {pickUpTime}
        </Paragraph3>
      }
      {isTakeAway &&
        <Paragraph3 className="paragraph">
          {languageContext[lanIndex].totalAmount}: {totalAmount ? totalAmount.toFixed(2) : 0}
        </Paragraph3>
      }
      {(isTakeAway && tkSuccessMessage != "") &&
        <Paragraph className="paragraph">{tkSuccessMessage && tkSuccessMessage != 'undefined' && tkSuccessMessage != " " ? tkSuccessMessage : (company._id == "66e08415c1eec69327a9417b" ? "" : (hasPaid ? languageContext[lanIndex].orderConfirm : languageContext[lanIndex].orderPrepare))}</Paragraph>
      }
      {(!isTakeAway && successMessage != "" && !hasPaid) &&
        <Paragraph className="paragraph">{successMessage && successMessage != 'undefined' && successMessage != " " ? successMessage : (company._id == "66e08415c1eec69327a9417b" ? "" : (hasPaid ? languageContext[lanIndex].orderConfirm : languageContext[lanIndex].orderPrepare))}</Paragraph>
      }
      <BillSummary themeContext={themeContext}>
        <OrderReceipt hideIdentity items={cartHistory} {...{ customerName, phone, address, scheduleTime, deliveryType, takeAwayId }} />
        <SubTotalWrapper themeContext={themeContext}>
          <SubtotalAndTaxContainer
            themeContext={themeContext}
          >
            <LeftColumn>
              {languageContext[lanIndex].subtotal}
            </LeftColumn>
            <RightColumn>
              {currencySymbol}&nbsp;{subtotalDefaultHistory.toFixed(2)}
            </RightColumn>
          </SubtotalAndTaxContainer>
          {subtotalDefaultHistory != subtotalHistory &&
            <SubtotalAndTaxContainer
              themeContext={themeContext}
            >
              <LeftColumn>
                {languageContext[lanIndex].discount}
              </LeftColumn>
              <RightColumn>
                {currencySymbol}&nbsp;{(subtotalHistory - subtotalDefaultHistory).toFixed(2)}
              </RightColumn>
            </SubtotalAndTaxContainer>

          }
          {(paymentData.serviceCharge > 0 || tax.tax > 0) &&
            <SubtotalAndTaxContainer
              themeContext={themeContext}
            >
              <LeftColumn>
                {tax.tax != 0 ? languageContext[lanIndex].tax : ""} {(isTakeAway && paymentData.shouldExclude) || paymentData.serviceCharge == 0 ? "" : `& ${languageContext[lanIndex].serviceCharge}`}
              </LeftColumn>
              <RightColumn>
                {currencySymbol}&nbsp;{(

                  subtotalHistory *
                  (1 + serviceAmt) *
                  (1 + tax.tax) -
                  subtotalHistory
                ).toFixed(2)}
              </RightColumn>
            </SubtotalAndTaxContainer>
          }
          {deliveryFee > 0 &&
            <SubtotalAndTaxContainer
              themeContext={themeContext}
            >
              <LeftColumn>
                {languageContext[lanIndex].deliveryFee}
              </LeftColumn>
              <RightColumn>
                {currencySymbol}&nbsp;{(deliveryFee).toFixed(2)}
              </RightColumn>
            </SubtotalAndTaxContainer>
          }
          {bcrsNo > 0 &&
            <SubtotalAndTaxContainer
              themeContext={themeContext}
            >
              <LeftColumn>
                BCRS Deposit
              </LeftColumn>
              <RightColumn>
                {currencySymbol}&nbsp;{(bcrsNo * 0.1).toFixed(2)}
              </RightColumn>
            </SubtotalAndTaxContainer>

          }
          <TotalContainer themeContext={themeContext}>
            <LeftColumn>
              {languageContext[lanIndex].total}
            </LeftColumn>
            <RightColumn>
              {currencySymbol}&nbsp;{
                //subtotalHistory +
                (
                  subtotalHistory *
                  (1 + serviceAmt) *
                  (1 + tax.tax)
                  + deliveryFee + bcrsNo * 0.1
                ).toFixed(2)
              }
            </RightColumn>
          </TotalContainer>
          {((!isTakeAway && !paymentData.shouldExclude) || ((paymentData.serviceCharge > 0 && !paymentData.shouldExcludeDI) || tax.tax > 0)) &&
            <DisclaimerContainer themeContext={themeContext}>
              *{languageContext[lanIndex].serviceChargeReminder}{paymentData.serviceCharge == 0 ? "" : "& " + languageContext[lanIndex].serviceCharge}
            </DisclaimerContainer>
          }
        </SubTotalWrapper>
      </BillSummary>
      {/* <div style={{ display: 'flex', justifyContent: "center", marginTop: 24 }}>
        <ViewBillButton
          themeContext={themeContext}
          onClick={handlingView}
        >
          {languageContext[lanIndex].reviewOrder}
        </ViewBillButton>
      </div> */}
      <OkButtonContainer themeContext={themeContext}>
        <Link to="/menu">
          <OkButton width={width} themeContext={themeContext}>
            {languageContext[lanIndex].returnMain}
          </OkButton>
        </Link>
      </OkButtonContainer>
      {showOrder &&
        <ReviewOrderModal
          show={showOrder}
          setShow={setShowOrder}
        />
      }
    </BackgroundColor>
  );


}

export default Success;
const BillSummary = styled.div`
  box-sizing: border-box; width: calc(100% - 32px); min-width: 0;
  margin: 20px 16px 24px; padding: 0; border-radius: 18px;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
  background: ${p => p.themeContext.backgroundColor};
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  box-shadow: 0 4px 16px rgba(0,0,0,.05);
  > section { box-sizing: border-box; min-width: 0; }
`;
const Divider = styled.div`
  border-bottom: 1px solid ${(props) => props.themeContext.borderColor};
  height: 1px;
  margin: 16px 16px;
`;
const ViewBillButton = styled.div`
  text-align: center;
  width: 150px;
  text-decoration: underline;
  color: ${(props) => props.themeContext.checkInPrimaryColor ? props.themeContext.checkInPrimaryColor : props.themeContext.primaryColor};
`;

const ContentWrapper = styled.div`
    flex-grow:1;
    overflow: auto;
    margin-top: 16px;
`;
const Header = styled.div`
    color: ${(props) => props.payAtCounter ? "#fcba03" : "#88B04B"};
    font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
    font-weight: 900;
    font-size: 20px;
    margin-top: 12px;
    text-align: center;
`;

const Paragraph = styled.div`
  padding-inline: 28px;
  box-sizing: border-box;
  line-height: 1.6;
color: #404F5E;
font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
font-size:15px;
margin-top: 20px;
text-align: center;
`;
const Paragraph2 = styled.div`
color: #404F5E;
font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
font-size:14px;
margin-top: 20px;
font-weight: 700;
text-align: center;
`;
const Paragraph3 = styled.div`
color: #404F5E;
font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
font-size: 18px;
margin-top: 20px;
font-weight: 700;
text-align: center;
`;

const Paragraph4 = styled.div`
color: #404F5E;
font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
font-size: 18px;
margin-top: 20px;
font-weight: 700;
text-align: center;
`;
const CheckIcon = styled.div`
    color: #9ABC66;
    font-size: 28px;
    line-height: 48px;
    margin-left: 0;
    text-align: center;
`;

const Circle = styled.div`
    border-radius:200px;
    height:48px;
    width:48px;
    background: #F8FAF5;
    margin:auto;
    margin-top: 20px;
`;

const BackgroundColor = styled.div`
  display: flex; flex-direction: column;
  height: 100vh;
  height: 100dvh; width: 100vw; max-width: 550px; margin: 0 auto;
  box-sizing: border-box; overflow-y: auto;
  background: ${p => p.themeContext.backgroundColor};
  > * { flex-shrink: 0; }
`;

const OkButtonContainer = styled.div`
  margin-top: auto;
  position: sticky; bottom: 0; z-index: 5; box-sizing: border-box; width: 100%;
  padding: 12px 16px max(12px, env(safe-area-inset-bottom));
  background: ${p => p.themeContext.backgroundColor};
  border-top: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
  a { display: block; text-decoration: none; }
`;

const OkButton = styled.div`
  display: flex; align-items: center; justify-content: center;
  box-sizing: border-box; width: 100%; min-height: 48px; padding: 12px 20px;
  border: 0; border-radius: 999px; text-align: center;
  color: ${p => actionTextColor(p.themeContext)};
  background: ${p => p.themeContext.primaryColor};
  font-family: ${p => p.themeContext.fontFamily}; font-size: 14px; font-weight: 600;
`;

const SubTotalWrapper = styled.div`
  box-sizing: border-box; width: 100%; padding: 16px;
  border-top: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
`;
const SubtotalAndTaxContainer = styled.div`
  display: flex; justify-content: space-between; gap: 12px;
  box-sizing: border-box; width: 100%; min-width: 0;
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily}; font-size: 13px; line-height: 1.5; padding-bottom: 8px;
`;
const LeftColumn = styled.div`
  flex: 1; min-width: 0; overflow-wrap: anywhere;
`;
const RightColumn = styled.div`
  flex-shrink: 0; text-align: right; font-variant-numeric: tabular-nums;
`;

const TotalContainer = styled.div`
  display: flex; justify-content: space-between; gap: 12px;
  box-sizing: border-box; width: 100%; min-width: 0;
  margin-top: 4px; padding-top: 12px;
  border-top: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily}; font-weight: 700; font-size: 17px;
`;

const DisclaimerContainer = styled.div`
  box-sizing: border-box; width: 100%; margin-top: 10px;
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily}; font-size: 11px;
  line-height: 1.5; opacity: .75; overflow-wrap: anywhere;
`;
